import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import NavbarModuloLF from '../../components/NavbarModuloFage';
import {
    SelectField, 
    renderNumber
} from "../../Utils/renderField/renderField";
const valEmp = __CONFIG__.empresa;

function PaisForm(props) {
    const { handleSubmit, crear, modulo, obtenerPaises, lectura } = props;
    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar pais' : 'Crear pais';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver pais'
    }
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    return (
        <div>
            {valEmp === 'fage' &&
                <NavbarModuloLF
                    modulo={modulo}
                    titulo={titulo}
                />
            }
            {valEmp === '' &&
                <NavbarModulo
                    modulo={modulo}
                    titulo={titulo}
                />
            }
            
            <br />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        <div className='mb-2'>
                            <div className='row mb-2'>
                                <div className='col-6'>
                                    {obtenerPaises &&
                                        <div className="form-floating">
                                            <Field
                                                name="pais"
                                                options={obtenerPaises}
                                                crear={crear}
                                                dato={crear === true ? 0 : lectura.pais_registro_sanitario}
                                                component={SelectField}
                                                className="form-select"
                                                disabled={disabled}
                                                msj="Pais"
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className='row mb-2'>
                                <div className='col-3'>
                                    <div className="form-floating">
                                        <Field
                                            name="tiempo"
                                            component={renderNumber}
                                            disabled={disabled}
                                            className="form-control"
                                            msj="Tiempo registro"
                                        />
                                    </div>
                                </div>
                                <div className='col-3'>
                                    <div className="form-floating">
                                        <Field
                                            name="tiempo_renovacion"
                                            component={renderNumber}
                                            disabled={disabled}
                                            className="form-control"
                                            msj="Tiempo de renovación"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex flex-row mt-3'>
                                {disabled == false &&
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={handleSubmit}
                                    >
                                        {editar ? 'Modificar' : 'Guardar'}
                                    </button>
                                }
                                {valEmp === 'fage' &&
                                    <a
                                        href={`/#/lfg/registro_sanitario/${id_emp[6]}/pais`}
                                        className='btn btn-secondary mb-3'
                                    >
                                        Regresar
                                    </a>
                                }
                                {valEmp === '' &&
                                    <a
                                        href={`/#/registro_sanitario/${id_emp[5]}/pais`}
                                        className='btn btn-secondary mb-3'
                                    >
                                        Regresar
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

PaisForm.propTypes = {
    handleSubmit: PropTypes.func,
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    modulo: PropTypes.object
};

export default reduxForm({
    form: 'FormPaisRS',
})(PaisForm);
